import ReportingTemplates from './container';

export default ReportingTemplates;
